import { buzz } from "./haptics";

const HOLD_MS = 600;
const SHOW_MS = 5000;
const FADE_OUT_MS = 500;

/**
 * Easter egg: long-press the "&" in the brand for ~600ms to flash a hidden
 * image full-screen for 5 seconds. Works for both touch and mouse.
 */
export function setupEasterEgg(): void {
  const amp = document.querySelector<HTMLElement>(".site-header__amp");
  if (!amp) return;

  // Prevent the iOS context menu and text selection on long-press
  amp.style.setProperty("-webkit-touch-callout", "none");
  amp.style.setProperty("-webkit-user-select", "none");
  amp.style.setProperty("user-select", "none");

  let timer: number | null = null;
  let triggered = false;

  const cancel = () => {
    if (timer !== null) {
      window.clearTimeout(timer);
      timer = null;
    }
  };

  amp.addEventListener("pointerdown", (e) => {
    triggered = false;
    cancel();
    timer = window.setTimeout(() => {
      triggered = true;
      timer = null;
      flashSecret();
    }, HOLD_MS);
    // Stop the click from bubbling to the brand link until we know if it
    // was a hold or a tap
    e.stopPropagation();
  });

  amp.addEventListener("pointerup", cancel);
  amp.addEventListener("pointerleave", cancel);
  amp.addEventListener("pointercancel", cancel);

  // Suppress the click-through navigation if the easter egg fired
  amp.addEventListener(
    "click",
    (e) => {
      if (triggered) {
        e.preventDefault();
        e.stopPropagation();
        triggered = false;
      }
    },
    true,
  );
  amp.addEventListener("contextmenu", (e) => e.preventDefault());
}

function flashSecret(): void {
  // Don't open multiple overlays if held repeatedly
  if (document.querySelector(".easter-overlay")) return;

  const overlay = document.createElement("div");
  overlay.className = "easter-overlay";
  overlay.setAttribute("aria-hidden", "true");

  const pic = document.createElement("picture");
  pic.innerHTML = `
    <source type="image/webp" srcset="/img/secret/easter-720.webp 720w, /img/secret/easter-1280.webp 1280w" sizes="100vw">
    <img src="/img/secret/easter-1280.jpg" srcset="/img/secret/easter-720.jpg 720w, /img/secret/easter-1280.jpg 1280w" sizes="100vw" alt="">
  `;
  overlay.appendChild(pic);
  document.body.appendChild(overlay);

  buzz("success");

  // Fade in next frame
  requestAnimationFrame(() => overlay.classList.add("is-visible"));

  // Allow tap-to-dismiss
  let dismissed = false;
  const dismiss = () => {
    if (dismissed) return;
    dismissed = true;
    overlay.classList.remove("is-visible");
    setTimeout(() => overlay.remove(), FADE_OUT_MS);
  };
  overlay.addEventListener("click", dismiss);
  setTimeout(dismiss, SHOW_MS);
}
